import React from "react";
import OverleafStore from "../../../../../../stores/overleaf-store";
import Presentation from "./presentation";
import PropTypes from "prop-types";
import { cardContentPropTypes, cardPropTypes } from "../../types";

export default class Card extends React.Component {
  constructor() {
    super();
    this.state = {
      editing: false,
      flipped: false
    };

    this.delete = this.delete.bind(this);
    this.edit = this.edit.bind(this);
    this.flip = this.flip.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.stopEditing = this.stopEditing.bind(this);
  }

  delete() {
    const {
      card: { deckUUID, uuid }
    } = this.props;
    OverleafStore.deleteCard(deckUUID, uuid);
    Fraction.Reporter.gaEvent("V3/flashcards/panel", deckUUID, "delete card");
  }

  edit() {
    this.setState({ editing: true });
  }

  flip() {
    this.setState(prevState => ({ flipped: !prevState.flipped }));
    Fraction.Reporter.gaEvent(
      "V3/flashcards/panel",
      `Flipped: ${!this.state.flipped}`,
      "flip card"
    );
  }

  onKeyDown(e) {
    if (e.keyCode === 13) {
      this.flip();
    }
  }

  stopEditing() {
    this.setState({ editing: false });
  }

  render() {
    const { editing, flipped } = this.state;
    const { card, isbn } = this.props;
    return (
      <Presentation
        cancel={this.stopEditing}
        card={card}
        destroy={this.delete}
        edit={this.edit}
        editing={editing}
        flip={this.flip}
        flipped={flipped}
        onKeyDown={this.onKeyDown}
        isbn={isbn}
      />
    );
  }
}

Card.propTypes = {
  card: cardPropTypes
};
